import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import { env } from 'core/utils';
import { loadingHide, loadingSetMessage, showAlert } from 'core/store/modules/common/actions';
import { API_ERROR_MESSAGE } from 'core/store/modules/common/literals';
import download from 'downloadjs';

import type { PdfProps } from './interface';
import getProcessResult from './utils/get-process-result';
import makeFilename from './utils/make-filename';
import mergePdfFiles from './utils/merge-pdf-files';

import { DEFAULT_CDN_CSS } from '../constants';
import { PDF_IS_DOWNLOADING, PDF_IS_GENERATING, PDF_IS_READY, PDF_IS_UPLOADING } from '../literals';

export const downloadPdf = (
  { chunks = [], filename, css = [], options = {}, pdf = [] }: PdfProps,
  dispatch: any,
) => {
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const url = `${env.PDF_SERVICE_URI}/api/v1`;

  const pdfFiles = mergePdfFiles(chunks);

  const config: AxiosRequestConfig = {
    url,
    data: {
      chunks,
      options,
      css: [DEFAULT_CDN_CSS, ...css],
      pdf: [...pdf, ...pdfFiles],
    },
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: 'blob',
    onUploadProgress: (progressEvent: any) => {
      const total = getProcessResult(progressEvent);

      const message = total !== 100 ? `${PDF_IS_UPLOADING} ${total}%` : PDF_IS_GENERATING;

      dispatch(loadingSetMessage(message));
    },
    onDownloadProgress: (progressEvent: any) => {
      const total = getProcessResult(progressEvent);

      dispatch(loadingSetMessage(`${PDF_IS_DOWNLOADING} ${total}%`));
    },
  };

  const file: string = makeFilename(filename);
  const contentType = 'application/pdf';

  axios(config)
    .then(({ data }: any) => {
      download(data, file, contentType);
      dispatch(showAlert(PDF_IS_READY, { variant: 'success' }));
    })
    .catch((error: any) => {
      dispatch(
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        showAlert(`${API_ERROR_MESSAGE}. ${error}`, {
          variant: 'error',
          timeout: 10,
        }),
      );
    })
    .then(() => {
      dispatch(loadingHide());
    });
};
